<template>
  <section
    class="blog-slider-section flex-box"
    :class="$store.getters['main/getBackgroundTone'](evenOdd)"
    :style="paddingCalculator"
  >
    <div class="container">
      <div class="products-head flex-box between">
        <h3 class="products-ttl font-38">
          {{ _.get(contentData, `conf.header.title`) }}
        </h3>
        <div class="products-head-right flex-box">
          <router-link
            v-if="_.get(contentData, `conf.header.full_list_url`)"
            :to="_.get(contentData, `conf.header.full_list_url`)"
            class="event-top-content-all flex-center  font-16 text-user-select uppercase"
            >{{
              _.get(contentData, `conf.header.full_list_title`)
            }}</router-link
          >
        </div>
      </div>
      <div class="products-slider-container">
        <swiper
          ref="productsSlider"
          class="blog-slider grab"
          :options="swiperOptions"
        >
          <template v-for="(product, index) in _.get(contentData, 'data.list')">
            <swiper-slide
              v-if="
                product.id !==
                  _.get(
                    $store.state.main.current_content,
                    'primary.data.list[0].id'
                  )
              "
              :key="index"
            >
              <room-item :blog="product" />
            </swiper-slide>
          </template>
          <div class="swiper-scrollbar" slot="scrollbar">
            <div
              class="swiper-scrollbar-drag"
              style="width: 30%"
              slot="scrollbar"
            ></div>
          </div>
        </swiper>

        <div class="nav-btns flex-box desk">
          <div class="btn-prev" slot="button-prev">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
            >
              <path
                id="Combined_Shape_Copy_2"
                data-name="Combined Shape Copy 2"
                d="M6.175,13.659a1.167,1.167,0,0,1,0-1.65l3.842-3.842H1.166a1.167,1.167,0,0,1,0-2.334h8.85L6.175,1.992A1.167,1.167,0,0,1,7.825.342l5.834,5.833.02.021.01.01.01.01.012.013.007.008.013.015.005.006.014.017,0,.005.014.018,0,0,.013.018,0,0,.013.018,0,.006.012.018,0,.007.01.016.005.009.008.014.007.012.006.011.009.016,0,.007.011.021v0a1.166,1.166,0,0,1-.24,1.359L7.825,13.659a1.167,1.167,0,0,1-1.65,0Z"
                transform="translate(0 0)"
                fill="#575757"
              />
            </svg>
          </div>
          <div class="btn-next" slot="button-next">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
            >
              <path
                id="Combined_Shape_Copy_2"
                data-name="Combined Shape Copy 2"
                d="M6.175,13.659a1.167,1.167,0,0,1,0-1.65l3.842-3.842H1.166a1.167,1.167,0,0,1,0-2.334h8.85L6.175,1.992A1.167,1.167,0,0,1,7.825.342l5.834,5.833.02.021.01.01.01.01.012.013.007.008.013.015.005.006.014.017,0,.005.014.018,0,0,.013.018,0,0,.013.018,0,.006.012.018,0,.007.01.016.005.009.008.014.007.012.006.011.009.016,0,.007.011.021v0a1.166,1.166,0,0,1-.24,1.359L7.825,13.659a1.167,1.167,0,0,1-1.65,0Z"
                transform="translate(0 0)"
                fill="#575757"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ArrowIcon from "../ArrowIcon";
import RoomItem from "../list/RoomItem.vue";
import ReportCard from "./ReportCard.vue";
export default {
  props: ["contentData", "evenOdd"],
  components: {
    ArrowIcon,
    ReportCard,
    RoomItem
  },
  data() {
    return {
      pTopDesktop: 144,
      pBottomDesktop: 89,
      pTopTablet: 89,
      pBottomTablet: 89,
      pTopMobile: 89,
      pBottomMobile: 89,

      swiperOptions: {
        spaceBetween: 30,
        slidesPerView: 2,
        speed: 800,
        grabCursor: true,
        watchOverflow: true,
        scrollbar: {
          el: ".swiper-scrollbar",
          hide: false,
          draggable: true,
          dragSize: 300
        },
        breakpoints: {
          320: {
            scrollbar: {
              dragSize: 129
            },
            slidesPerView: 1
          },
          414: {
            scrollbar: {
              dragSize: 176
            },
            slidesPerView: 1
          },
          500: {
            scrollbar: {
              dragSize: 176
            },
            slidesPerView: 2
          }
        },

        navigation: {
          nextEl: ".btn-next",
          prevEl: ".btn-prev"
        },

        touchStartPreventDefault: false,

        on: {
          touchMove() {
            document
              .querySelectorAll(".blog-slider .swiper-slide")
              .forEach(slide => {
                slide.style.transform = "scale(0.90, 0.90)";
                slide.style.transition = "0.6s ease";
              });
          },
          touchEnd() {
            document
              .querySelectorAll(".blog-slider .swiper-slide")
              .forEach(slide => {
                slide.style.transform = "scale(1, 1)";
                slide.style.transition = "0.6s ease";
              });
          }
        }
      }
    };
  },
  methods: {
    slideCount() {
      let slide = document.querySelectorAll(".blog-slider .swiper-slide");
      let slider = document.querySelector(".blog-slider-section");

      if (slide.length <= 4) {
        slider.classList.add("hide-nav");
      }
    }
  },
  mounted() {
    this.slideCount();
  }
};
</script>

<style scoped>
.swiper-container.blog-slider {
  transition: 0.4s;
  overflow: visible;
}
.blog-slider-section .container {
  width: 100%;
}
.blog-slider .swiper-slide {
  display: flex;
  max-width: 540px;
  flex-direction: column;
  height: unset;
  -webkit-tap-highlight-color: transparent;
  /* transition: 0.3s; */
}
.blog-slider .swiper-slide .product-box {
  cursor: move; /* fallback if grab cursor is unsupported */
  cursor: grab;
  cursor: -moz-grab;
  cursor: -webkit-grab;
  overflow: hidden;
  /* width: 255px; */
}

/* (Optional) Apply a "closed-hand" cursor during drag operation. */
.blog-slider .swiper-slide .product-box:active {
  cursor: grabbing;
  cursor: -moz-grabbing;
  cursor: -webkit-grabbing;
}
.blog-slider-section {
  overflow-x: hidden;
}
.blog-slider-section.light .bg-left,
.blog-slider-section.light .bg-right {
  background: var(--primary);
}
.blog-slider-section.dark .bg-left,
.blog-slider-section.dark .bg-right {
  background: var(--gray);
}
.bg-left,
.bg-right {
  position: relative;
  width: 100%;
  z-index: 999;
}

/* body[data-theme="night"] .bg-left,
body[data-theme="night"] .bg-right {
  background-color: #222222;
} */
body[data-theme="night"] .products-head a {
  color: rgba(218, 218, 218, 0.6);
}
.swiper-scrollbar {
  background-color: #364756;
  height: 2px !important;
}
body[data-theme="night"] .swiper-scrollbar {
  background-color: #555555;
}
.swiper-scrollbar-drag {
  top: -1px;
  background: #00a3e0;
  height: 4px;
  cursor: pointer;
}

.swiper-container-horizontal > .swiper-scrollbar {
  left: 0;
  position: relative;
  bottom: unset;
  width: 88% !important;
}
.blog-slider-section .nav-btns.desk {
  justify-content: flex-end;
  margin-top: -10px;
  width: fit-content;
  margin-left: auto;
}

.btn-prev,
.btn-next {
  cursor: pointer;
}
.btn-prev svg,
.btn-next svg {
  transition: 0.6s;
}
.btn-prev svg path,
.btn-next svg path {
  transition: 0.6s;
  fill: #6c7a8a;
}
@media (min-width: 1025px) {
  .btn-prev:hover svg path,
  .btn-next:hover svg path {
    fill: #00aeef;
  }
  .product-box:hover .img-box {
    transform: scale(1);
  }
  .product-box:hover > .product-ttl {
    transform: translateX(0);
  }
}

.swiper-button-disabled svg path {
  /* fill: #c6c6c6; */
}
.swiper-button-disabled:hover svg path {
  fill: #c6c6c6;
}
.btn-prev {
  margin-right: 32px;
}
.btn-prev svg {
  transform: rotate(180deg);
}
.products-head a {
  color: #00aeef;
  /* text-decoration: underline; */
  text-decoration-color: transparent;
  transition: 0.6s;
  white-space: nowrap;
}
.products-ttl {
  margin-right: 20px;
}
.products-head-right {
  margin-top: 6px;
}
.products-head-right a {
  color: var(--tbc-blue);
}
body[data-theme="night"] .products-head a {
  color: rgba(218, 218, 218, 0.6);
}
.products-head a:hover {
  text-decoration-color: #00aeef;
}
body[data-theme="night"] .products-head a:hover {
  text-decoration-color: rgba(218, 218, 218, 0.6);
}
.products-slider-container {
  margin-top: 55px;
}

.product-box .img-box {
  width: 255px;
  height: 255px;
  z-index: 2;
  transition: 0.6s;
  will-change: transform;
}
.img-overlay {
  background: rgba(0, 76, 186, 0.2);
  opacity: 0;
  transition: 0.7s;
}
.product-ttl {
  position: relative;
  z-index: 9;
  margin-top: 20px;
  max-width: calc(100% - 36px);
  transform: translateX(-24px);
  transition: 0.6s;
  backface-visibility: hidden;
  will-change: transform;
  cursor: pointer;
}
.product-ttl.sec {
  opacity: 0;
  visibility: hidden;
  max-width: 100%;
}
.details-ttl {
  font-size: 13px;
  color: rgba(129, 129, 141, 0.9);
}
.product-rate,
.product-desc {
  color: #004cba;
}
.product-desc {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
}
.product-rate {
  margin: 3px 0;
}
.light .hover-content {
  background: var(--gray);
}
.dark .hover-content {
  background: var(--primary);
}
body[data-theme="night"] .hover-content {
  background: white;
}
.hover-content {
  position: absolute;
  top: 0;
  background: #ffffff;
  width: 100%;
  opacity: 0;
  transition: 0.4s;
  padding-top: 255px;
  padding-right: 18px;
  padding-bottom: 18px;
  padding-left: 18px;
  pointer-events: none;
  cursor: pointer;
}
.product-details-box {
  margin-top: 15px;
  padding: 13px 15px;
  background: rgba(232, 232, 232, 0.5);
  border-radius: 10px;
  border: 1px solid #d9d9d9;
  transform: translateY(10px);
  transition: 0.6s;
  will-change: transform;
  backface-visibility: hidden;
}
.arrow-icon {
  margin-right: 9px;
  opacity: 0;
  transition: 0.6s;
}

@media (min-width: 1025px) {
  /* Product Box Hover Styles */
  .product-box:hover .img-overlay {
    opacity: 1;
  }
  .product-box:hover .product-ttl {
    color: rgb(0, 174, 239);
  }
  .product-box:hover .hover-content {
    opacity: 1;
    pointer-events: all;
  }
  .product-box:hover .img-box {
    transform: scale(0.86);
  }
  .product-box:hover > .product-ttl {
    transform: translateX(18px);
  }
  .product-box:hover .arrow-icon {
    opacity: 1;
  }
  .product-box:hover .product-details-box {
    transform: translateY(0);
  }
  body[data-theme="night"] .product-box:hover .product-ttl {
    color: #333333;
  }
}
.blog-slider-section.hide-nav .bg-left,
.blog-slider-section.hide-nav .bg-right {
  display: none;
}
@media (max-width: 1169px) {
  .blog-slider .swiper-slide {
    width: 210px;
  }
  .product-box .img-box {
    width: 210px;
    height: 210px;
  }
  .hover-content {
    padding-top: 210px;
  }
  .products-slider-container {
    margin-top: 34px;
  }
}
@media (max-width: 1023px) {
  .blog-slider .swiper-slide >>> .room-item {
    /* height: 400px; */
  }
  .swiper-container-horizontal > .swiper-scrollbar {
    width: 75% !important;
  }
  .products-slider-container {
    margin-top: 34px;
  }
  .swiper-container.blog-slider {
    overflow: visible;
  }
  .product-box .img-box {
    width: 206px;
    height: 206px;
  }
  .hover-content,
  .img-overlay,
  .product-ttl.sec {
    display: none;
  }

  .product-ttl {
    max-width: unset;
  }
}

@media (min-width: 768px) {
  .nav-btns.mob {
    display: none;
  }
}
@media (max-width: 767px) {
  .blog-slider .swiper-slide >>> .room-item {
    /* height: 300px; */
  }
  .swiper-container-horizontal > .swiper-scrollbar {
    width: 75% !important;
  }
  .products-ttl.font-38 {
    font-size: 24px;
  }
  .products-head-right {
    margin-top: 0;
  }
  .product-box .img-box {
    width: 278px;
    height: 278px;
  }
  .nav-btns.mob {
    justify-content: center;
  }
  .btn-prev {
    margin-right: 30px;
  }
}
@media (max-width: 413px) {
  .product-box .img-box {
    width: 206px;
    height: 206px;
  }
  .blog-slider-section .nav-btns.desk {
    padding-right: 0;
  }
}
</style>
<style>
.blog-slider .swiper-wrapper {
  padding-bottom: 63px;
  z-index: 99;
}
.blog-slider.swiper-container-horizontal > .swiper-scrollbar {
  width: 100%;
}

@media (max-width: 767px) {
  .blog-slider .swiper-wrapper {
    padding-bottom: 34px;
  }
}
</style>
